import { useEffect } from 'react';
import type { VoidFunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NotFound from '../../../generic/NotFound';
import type { ReportGenerationParams } from '../shared/types';
import { getReportURL, ReportCategoryKeys, ReportActions } from './utils';
import * as ReportGenerationStore from '../../../../redux/reportGeneration';
import SidePanel from './SidePanel';
import HTMLPreview from './HTMLPreview';
import { SidebarLayout } from '../../../layouts';
import Loader from '../../../generic/Loader';

type Props = {
  params: ReportGenerationParams,
};

const ReportGeneration: VoidFunctionComponent<Props> = ({
  params,
}: Props) => {
  const dispatch = useDispatch();
  const { report_type: reportType } = params;
  const projectType = useSelector(ReportGenerationStore.selectors.getProjectType);
  const format = useSelector(ReportGenerationStore.selectors.getFormat);

  const reportContext = useSelector(ReportGenerationStore.selectors.getReportContext);
  const reportOptions = useSelector(ReportGenerationStore.selectors.getReportOptions);

  useEffect(() => {
    dispatch(ReportGenerationStore.actions.setCategory(reportType));
  }, [dispatch, reportType]);

  if (!ReportCategoryKeys.includes(reportType)) {
    return <NotFound />;
  }

  if (!projectType) {
    return <Loader />;
  }

  const reportPreviewUrl = getReportURL(ReportActions.Preview, reportContext, reportOptions);

  return (
    <div className="container container-responsive">
      <SidebarLayout>
        <SidebarLayout.Sidebar>
          <SidePanel />
        </SidebarLayout.Sidebar>
        <SidebarLayout.Main>
          <HTMLPreview
            projectType={projectType}
            format={format}
            previewURL={reportPreviewUrl}
          />
        </SidebarLayout.Main>
      </SidebarLayout>
    </div>
  );
};

export default ReportGeneration;
